
import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CustomEmptyView from "../../../Components/CustomEmptyView";
import Strings from "../../../Config/Strings";
import { deleteMenuDetailsAPI } from "../../../Store/Action/menu";
import Colors from "../../../theme/Colors";
import MenuTableBody from "./Controls/MenuTableBody";
import MenuTableHeader from "./Controls/MenuTableHeader";
import Pagination from "../../../Components/Pagination";

const MenuTable = ({ menu, rowsPerPage, handleChangePage, totalItems }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [menuIdToDelete, setMenuIdToDelete] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  const handleOpen = useCallback(() => setModalVisible(true), []);
  const handleClose = useCallback(() => setModalVisible(false), []);
  const handleCancelDelete = useCallback(() => {
    setShowDeleteModal(false);
  }, []);
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate total pages based on totalItems and rowsPerPage
  const totalPages = Math.ceil(totalItems / rowsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    handleChangePage(null, newPage - 1); // Adjusting index as per 0-based index system
  };

  const handleShowDeleteModal = useCallback((menuId) => {
    setMenuIdToDelete(menuId);
    setShowDeleteModal(true);
  }, []);

  const onViewMenuDetails = useCallback(
    (menuId) => {
      navigate(`/menu/${menuId?.menu_id}`, { state: { menuId } });
    },
    [navigate]
  );

  const onEditMenuDetails = useCallback(
    (editMenu) => {
      navigate(`/menu/edit`, { state: { editMenu } });
    },
    [navigate]
  );

  const handleDeleteMenu = async () => {
    try {
      await dispatch(
        deleteMenuDetailsAPI(menuIdToDelete, (isSuccess, response) => {
          setShowDeleteModal(false);
          setLoading(false);
          if (isSuccess?.status === true) {
            toast.success(response?.data?.message);
            setTimeout(() => {
              window.location.reload();
            }, 400);
          } else {
            const errorMessage =
              response?.error?.message || Strings.somethingWentWrongError;
            toast.error(errorMessage);
          }
        })
      );
    } catch (error) {
      console.log("Error dispatching addProducts:", error);
      setLoading(false);
      toast.error(Strings.somethingWentWrongError);
    }
  };

  return (
    <div style={mainContainer}>
      <div style={outerWrapper}>
        <div style={tableWrapper}>
          <div style={{ minWidth: "110%" }}>
            {menu?.length === 0 ||
            menu?.length === undefined ||
            menu?.length === null ? (
              <div style={{ width: "70vw" }}>
                <CustomEmptyView />
              </div>
            ) : (
              <>
                <table style={table}>
                  <MenuTableHeader />
                  <MenuTableBody
                    menuDetails={menu}
                    onViewMenuDetails={onViewMenuDetails}
                    onEditMenuDetails={onEditMenuDetails}
                    handleShowDeleteModal={handleShowDeleteModal}
                  />
                </table>
              </>
            )}
          </div>

        
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
        </div>
      </div>
    </div>
  );
};

const mainContainer = {
  borderRadius: "10px",
  marginTop: "25px",
  marginLeft: "22px",
  width: "97%",
  height: "76vh", // Control height for scrolling
  display: "flex",
  flexDirection: "column",
};

const outerWrapper = {
  borderRadius: "4px",
  boxShadow: "0px 0px 3px #e6e6e6",
  maxWidth: "100%",
  height: "100%",
  backgroundColor: Colors.white,
  display: "flex",
  flexDirection: "column",
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
};

const tableWrapper = {
  overflowY: "auto", // Ensure vertical scroll
  overflowX: "scroll",
  flexGrow: 1, // Allow table to grow and pagination to stay at the bottom
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
};

const table = {
  minWidth: "100%",
  borderCollapse: "separate",
  borderSpacing: "0px",
};


export default MenuTable;
